import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  open() {
    this.modalTarget.classList.remove("hidden")
    // Redraw charts after modal is visible so Chart.js gets correct dimensions
    requestAnimationFrame(() => {
      if (window.Chartkick) {
        Object.values(Chartkick.charts).forEach(chart => chart.redraw())
      }
    })
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
